import React, { useEffect, useState } from 'react';
import QuizTextAnswer from '@anu/components/QuizTextAnswer';
import PropTypes from 'prop-types';
import {
  getStoredQuestion,
  setStoredQuestion,
} from '../utilities/session.question';
import { coursePropTypes } from '@anu/utilities/transform.course';

/**
 * Extends original `QuizTextAnswerHandler` to support private sessions.
 */

const QuizTextAnswerHandler = (props) => {
  const defaultValue = '';
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [value, setValue] = useState(defaultValue);

  useEffect(() => {
    // During the initialization set the default value for the widget.
    if (props.isQuiz) {
      props.onChange(defaultValue);
    }
    // Check user session for lessons.
    else if (props.course && props.course.private_sessions) {
      const submittedAnswer = getStoredQuestion(props.aqid);
      if (submittedAnswer) {
        setValue(submittedAnswer);
        setIsSubmitted(true);
        props.onQuestionComplete(props.aqid);
      }
    }
  }, []);

  const onChange = (event) => {
    const value = event.target.value;
    setValue(value);
    props.onChange(value);

    setStoredQuestion(props.aqid, value);
    setIsSubmitted(true);
    props.onQuestionComplete(props.aqid);
  };

  return (
    <QuizTextAnswer
      question={props.question}
      value={props.submittedAnswer || value}
      correctValue={props.correctQuizValue}
      isSubmitting={props.isSubmitting}
      isSubmitted={props.isSubmitted || isSubmitted}
      multiline={props.bundle === 'question_long_answer'}
      onChange={onChange}
    />
  );
};

QuizTextAnswerHandler.propTypes = {
  course: coursePropTypes,
  aqid: PropTypes.number,
  question: PropTypes.string,
  scale: PropTypes.object,
  value: PropTypes.string,
  defaultValue: PropTypes.number,
  correctQuizValue: PropTypes.string,
  isSubmitting: PropTypes.bool,
  isSubmitted: PropTypes.bool,
  onSubmit: PropTypes.func,
  onChange: PropTypes.func,
  onQuestionComplete: PropTypes.func,
  isQuiz: PropTypes.bool,
  bundle: PropTypes.string,
  submittedAnswer: PropTypes.string,
};

QuizTextAnswerHandler.defaultProps = {
  onSubmit: () => {},
  onChange: () => {},
  onQuestionComplete: () => {},
  submittedAnswer: '',
};

export default QuizTextAnswerHandler;
